import { axiosPRest } from '@mais-retorno-front/configs/axios-config';
import { GetFundInitialRankingPageUseCase } from '@mais-retorno-front/core-business/useCases/fund-ranking/get-fund-initial-ranking-page';

export const makeGetFundInitialRankingPageUseCase = () => {
  return new GetFundInitialRankingPageUseCase(axiosPRest);
};
